import React from 'react'
import { EmojiSmile } from 'react-bootstrap-icons'

const GoalName = ({
    goal = {}
}) => {
    return (
        <React.Fragment>
            {goal.title}
        </React.Fragment>
    )
}

export default GoalName